import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
  this.skillCateValidation = function () {
    const dictonary = {
      custom: {
        SkillCate: {
          required: () => t.t(dictEnum.LBL_SkillCate) + t.t(dictEnum.WARN_IsRequired)
        },
        SkillCateItem: {
          required: () => t.t(dictEnum.LBL_Item) + t.t(dictEnum.WARN_IsRequired)
        },
        Seq: {
          required: () => t.t(dictEnum.LBL_Seq) + t.t(dictEnum.WARN_IsRequired)
        },
        AnsType: {
          required: () => t.t(dictEnum.LBL_AnsType) + t.t(dictEnum.WARN_IsRequired)
        },
        Option: {
          required: () => t.t(dictEnum.LBL_Option) + t.t(dictEnum.WARN_IsRequired)
        },
        CDesc: {
          required: () => t.t(dictEnum.LBL_ChiDesc) + t.t(dictEnum.WARN_IsRequired)
        },
        EDesc: {
          required: () => t.t(dictEnum.LBL_EngDesc) + t.t(dictEnum.WARN_IsRequired)
        },
      }
    };
    Validator.localize('en', dictonary);
  }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S080400-SkillCerts/S080400-SkillCertsValidation.js